import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

// MUI Imports
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
// import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

export const WardrobeTableFilterBar = ({
  wardrobeFilter,
  setWardrobeFilter,
}) => {
  const [currentSearchValue, setCurrentSearchValue] = useState(
    wardrobeFilter.search || "",
  );
  const queryClient = useQueryClient();

  // const handleStatusChange = (e) => {
  //   setWardrobeFilter((prevState) => ({
  //     ...prevState,
  //     status: e.target.value,
  //   }));
  //   invalidateWardrobesQuery();
  // };

  const handleSearchChange = (newValue) => {
    setCurrentSearchValue(newValue.target.value);
  };

  const handleSearchSumbit = (e) => {
    e.preventDefault();
    setWardrobeFilter((prevState) => ({
      ...prevState,
      search: currentSearchValue,
    }));
    invalidateWardrobesQuery();
  };

  const handleSearchClear = () => {
    setCurrentSearchValue("");
    setWardrobeFilter((prevState) => ({
      ...prevState,
      search: "",
    }));
    invalidateWardrobesQuery();
  };

  const invalidateWardrobesQuery = () => {
    queryClient.invalidateQueries({
      queryKey: ["wardrobeListState"],
      exact: true,
    });
  };

  return (
    <Stack direction={{ xs: "column", md: "row" }} spacing={{ xs: 2, md: 1 }}>
      <Box component="form" onSubmit={handleSearchSumbit} sx={{ flexGrow: 1 }}>
        <TextField
          onChange={handleSearchChange}
          value={currentSearchValue}
          label="Search.."
          id="wardrobe-table-search"
          name="Search"
          variant="outlined"
          size="small"
          fullWidth
          slotProps={{
            input: {
              endAdornment: (
                <>
                  <InputAdornment
                    position="end"
                    sx={{
                      visibility: currentSearchValue ? "visible" : "hidden",
                    }}
                  >
                    <IconButton onClick={handleSearchClear} color="error">
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                  <InputAdornment position="end">
                    <IconButton type="submit">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                </>
              ),
            },
          }}
        />
      </Box>

      {/* <Stack direction="row" spacing={1} sx={{ minWidth: { md: 400 } }}>
        <TextField
          onChange={handleStatusChange}
          id="contract-status"
          select
          label="Contract Status"
          value={contractFilter.status}
          fullWidth
        >
          <MenuItem value={"All"}>All</MenuItem>
          <MenuItem value={"Active"}>Active</MenuItem>
          <MenuItem value={"Inactive"}>Blocked</MenuItem>
        </TextField>
      </Stack> */}
    </Stack>
  );
};
